<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Contract from "@/components/modals/contract-history.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";

export default {
  page: {
    title: "Incoming Deliveries",
  },
  components: {
    Layout,
    PageHeader,
    Contract,
    UploadPopover,
  },
  data() {
    return {
      title: "Incoming Deliveries",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Incoming Deliveries",
          active: true,
        },
      ],
      totalRows: 1,
      po: {
        id: null,
        description: "",
      },
      tableData: [],
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      loading: false,
      tabIndex: 0,
      statusSelect: "Ongoing",
      statusOptions: [
        "Ongoing",
        "To Expire",
        "Expired",
        "With Pending Extension",
        "With Extension",
        "With Pending Suspension",
        "With Suspension",
        "All",
      ],
      campusId: this.$store.state.data.selectedCampus.id,
      cycle: this.$store.state.data.cycle,
      isAdmin: this.$store.state.decrypt.isAdmin(),
      token: this.$store.state.decrypt.getToken(),
      uploadOptions: {
        type: "Purchase Order",
        placement: "lefttop",
        folder: "Property",
      },
    };
  },
  computed: {
    filtered() {
      // Optimize filtering by checking status first
      let isExtensionStatus = ["With Pending Extension", "With Extension",
        "With Pending Suspension", "With Suspension"].includes(this.statusSelect);

      // For extension statuses, preload extensions data in batches
      if (isExtensionStatus && this.tableData.length > 0) {
        // Only preload extension data for visible items (within current page range)
        const startIdx = (this.currentPage - 1) * this.perPage;
        const endIdx = Math.min(startIdx + this.perPage + 5, this.tableData.length); // Load a few extra for scrolling
        for (let i = startIdx; i < endIdx; i++) {
          if (i >= 0 && i < this.tableData.length && !this.tableData[i].extensionsLoaded) {
            this.loadContractExtensions(this.tableData[i]);
          }
        }
      }

      let data = this.tableData;
      data = data.filter((item) => {
        if (this.statusSelect == "Ongoing")
          return (
            this.checkDeliveryDate(
              new Date(item.expectedDelivery),
              item.numberOfDays
            ) == "ongoing"
          );
        else if (this.statusSelect == "To Expire")
          return (
            this.checkDeliveryDate(
              new Date(item.expectedDelivery),
              item.numberOfDays
            ) == "warning"
          );
        else if (this.statusSelect == "Expired")
          return (
            this.checkDeliveryDate(
              new Date(item.expectedDelivery),
              item.numberOfDays
            ) == "expired"
          );
        else if (this.statusSelect == "With Pending Extension")
          return this.hasExtensionWithStatus(item, "EXTENSION", "PENDING");
        else if (this.statusSelect == "With Extension")
          return this.hasExtensionWithStatus(item, "EXTENSION", "APPROVED");
        else if (this.statusSelect == "With Pending Suspension")
          return this.hasExtensionWithStatus(item, "SUSPENSION", "PENDING");
        else if (this.statusSelect == "With Suspension")
          return this.hasExtensionWithStatus(item, "SUSPENSION", "APPROVED");
        else return item;
      });
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.description.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.description
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.poNumber.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.poNumber
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          else if (
            item.supplierName.toUpperCase().includes(this.filter.toUpperCase())
          )
            return item.supplierName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
  },
  created() {
    this.changeCampus();
  },
  watch: {
    // Watch for page changes to load extension data for visible items
    currentPage: {
      handler() {
        this.$nextTick(() => {
          this.loadVisibleExtensionData();
        });
      }
    },
    // Watch for status changes to load relevant extension data
    statusSelect: {
      handler(newVal) {
        if (["With Pending Extension", "With Extension",
          "With Pending Suspension", "With Suspension"].includes(newVal)) {
          this.$nextTick(() => {
            this.loadVisibleExtensionData();
          });
        }
      }
    }
  },
  methods: {
    changeCampus() {
      this.campusId = this.$store.state.data.selectedCampus.id;
      this.cycle = this.$store.state.data.cycle;
      this.getContractPending();
    }, getContractPending() {
      this.loading = true;
      var cycle = this.cycle;
      var campusId = this.campusId;
      this.$store
        .dispatch("inspectioncontract/GetInspectionContractPending", {
          cycle,
          campusId,
        })
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          res.data.forEach((x) => {
            x.loading = false;
            x.visible = false;
            x.toggleAll = false;
            x.allIarName = 0;
            x.rfqSupplierOffers = [];
            x.addDocu = false;
            x.attachmentLoading = false;
            x.poFiles = [];
            x.viewFile = false;

            // Initialize extension-related properties
            x.extensionsLoaded = false;
            x.extensionsLoading = false;
            x.poDeliveryExtensions = null;
          });
          this.tableData = res.data
            .sort(function (a, b) {
              return b.expectedDelivery.localeCompare(
                a.expectedDelivery
              );
            })
            .sort(function (a, b) {
              return b.withPendingExtension - a.withPendingExtension;
            });

          // If we're on one of the extension tabs, load the extension data
          if (["With Pending Extension", "With Extension",
            "With Pending Suspension", "With Suspension"].includes(this.statusSelect)) {
            this.$nextTick(() => {
              this.loadVisibleExtensionData();
            });
          }
        })
        .catch((err) => {
          this.showToast(
            "Something went wrong - Getting incoming deliveries!",
            "error"
          );
          this.loading = false;
        });
    },
    getRfqItems(row) {
      row.visible = !row.visible;
      if (row.visible) {
        row.loading = true;
        row.toggleAll = false;
        setTimeout(() => {
          this.$store
            .dispatch("rfqsupplieroffer/GetRSOWinner", row.rfqSupplierId)
            .then((res) => {
              res.data.forEach((y) => {
                y.iarName = 0;
                y.toggleSelected = false;
              });
              row.rfqSupplierOffers = res.data;
              row.loading = false;
            });
        }, 1000);
      }
    },
    getSuspension(row) {
      // Make sure we're passing a row with loaded extension data
      if (!row.extensionsLoaded) {
        this.loadContractExtensions(row);
      }
      this.$refs.contract.getSuspension(row, "POST");
      this.$bvModal.show("modal-contract");
    },
    checkDeliveryDate(deliveryDate, days) {
      var warningDays = days < 4 ? 1 : ~~(days / 4);
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + warningDays
      );
      if (deliveryDate <= today) return "expired";
      else if (deliveryDate < nextweek) return "warning";
      else return "ongoing";
    },
    uploadDocument(response, id) {
      var index = this.tableData.findIndex((x) => x.id == id);
      this.tableData[index].poFiles.push(response);
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    searchDocu(row) {
      let data = row.poFiles;
      if (row.fileSearch.trim() != "" && row.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(row.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    uploadedFiles() { },
    getAttachments(row) {
      row.viewFile = true;
      row.poFiles = [];
      row.attachmentLoading = true;
      this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type,
        })
        .then((res) => {
          row.attachmentLoading = false;
          row.poFiles = res.data;
        })
        .catch(() => {
          row.attachmentLoading = false;
          this.showToast("Something went wrong - Getting documents!", "error");
        });
    },
    removeFile(id, parentId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == parentId
              );
              let yIndex = this.tableData[index].poFiles.findIndex(
                (item) => item.id == id
              );
              this.tableData[index].poFiles.splice(yIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    readFile(id) {
      this.$store.dispatch("filemanager/GetFileUrl", id);
    },
    // New method to load contract extensions efficiently
    loadContractExtensions(item) {
      if (!item.extensionsLoaded) {
        item.extensionsLoaded = true;
        item.extensionsLoading = true;
        this.$store
          .dispatch("inspectionextension/GetDeliveryExtensionByPo", item.id)
          .then((res) => {
            item.poDeliveryExtensions = res.data || [];
            item.extensionsLoading = false;
          })
          .catch(() => {
            item.poDeliveryExtensions = [];
            item.extensionsLoading = false;
          });
      }
    },
    // Helper method to check if a PO has extensions with specific type and status
    hasExtensionWithStatus(item, type, status) {
      // First ensure we have extensions data loaded
      if (!item.poDeliveryExtensions) {
        this.loadContractExtensions(item);

        // For backward compatibility, use the withPendingExtension property
        // but only for EXTENSION+PENDING combination
        return (type === "EXTENSION" && status === "PENDING") ? item.withPendingExtension : false;
      }

      // Look through the poDeliveryExtensions to find the specified type and status
      return item.poDeliveryExtensions.some(ext =>
        ext.type === type && ext.status === status
      );
    },
    // Load extension data in batches for visible items
    loadVisibleExtensionData() {
      const isExtensionStatus = ["With Pending Extension", "With Extension",
        "With Pending Suspension", "With Suspension"].includes(this.statusSelect);

      if (isExtensionStatus && this.tableData.length > 0) {
        // Process items in small batches to avoid freezing the UI
        const batchSize = 5;
        const startIdx = (this.currentPage - 1) * this.perPage;
        const endIdx = Math.min(startIdx + this.perPage, this.tableData.length);

        // Create a function to process items in batches
        const processBatch = (start) => {
          const end = Math.min(start + batchSize, endIdx);

          for (let i = start; i < end; i++) {
            if (i >= 0 && i < this.tableData.length && !this.tableData[i].extensionsLoaded) {
              this.loadContractExtensions(this.tableData[i]);
            }
          }

          // Process the next batch if needed
          if (end < endIdx) {
            setTimeout(() => {
              processBatch(end);
            }, 100);
          }
        };

        // Start processing batches
        processBatch(startIdx);
      }
    },
  },
};
</script>
<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
      <b-tab v-for="(status, index) in statusOptions" :key="index" @click="
        statusSelect = status;
      perPage = 10;
      currentPage = 1;
      ">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="mdi mdi-clock-time-four-outline"></i>
          </span>
          <span class="d-none d-sm-inline-block">{{ status }}</span>
        </template>
        <div v-if="tabIndex == index">
          <div class="d-flex justify-content-between mb-2">
            <h4 class="m-0 pt-3">P.O. List</h4>
            <div class="d-flex align-items-center">
              <div id="tickets-table_filter" class="tableDatas_filter me-1">
                <label class="d-inline-flex align-items-center">
                  <b-form-input autocomplete="off" v-model="filter" type="search" placeholder="Search PO..."
                    class="form-control"></b-form-input>
                </label>
              </div>
              <div id="tickets-table_length" class="tableDatas_length">
                <label class="d-inline-flex align-items-center">
                  <b-form-select class="form-select" v-model="perPage" size="sm" :options="pageOptions">
                  </b-form-select>
                </label>
              </div>
            </div>
          </div>
          <div class="h-50vh d-flex align-items-center justify-content-center" v-if="loading">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
          <div class="h-50vh d-flex align-items-center justify-content-center" v-else-if="paginated.length == 0">
            <h5 v-if="filter != ''" class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>Search Not Found
            </h5>
            <h5 v-else class="text-muted">
              <i class="fas fa-exclamation-triangle me-2"></i>No Data Found
            </h5>
          </div>
          <div v-else>
            <div role="tablist" v-for="x in paginated" :key="x.id">
              <b-card no-body class="mb-1 position-relative">
                <b-card-header header-tag="header" role="tab">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <div class="d-flex align-items-center" style="min-width: max-content">
                        <div class="text-white">PO# {{ x.poNumber }}</div>
                        <div class="ms-2">|</div>
                        <small class="ms-2">
                          {{ x.supplierName }}
                        </small>
                      </div>
                      <div class="text-white font-size-14 mb-1">
                        {{ x.description }}
                      </div>
                      <div class="d-flex align-items-center" style="min-width: max-content">
                        <div v-b-tooltip.bottomleft.hover="'Expected Date of Delivery'
                          " class="badge bg-soft" :class="checkDeliveryDate(
                            new Date(x.expectedDelivery),
                            x.numberOfDays
                          ) == 'ongoing'
                            ? 'bg-success'
                            : checkDeliveryDate(
                              new Date(x.expectedDelivery),
                              x.numberOfDays
                            ) == 'warning'
                              ? 'bg-warning text-warning'
                              : 'bg-danger text-danger'
                            ">
                          <b class="font-size-12">{{
                            formatDate(new Date(x.expectedDelivery))
                          }}</b>
                        </div>
                        <div class="ms-2">|</div>
                        <small class="ms-1">
                          <a href="javascript: void(0);" class="text-success d-flex align-items-center ms-1"
                            @click="getRfqItems(x)">
                            {{ x.visible ? "Hide" : "Show" }}
                            Items
                            <i class="bx bx-chevron-right rotate font-size-14" :class="{
                              'rotate-90': x.visible,
                            }"></i>
                          </a>
                        </small>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <span v-if="hasExtensionWithStatus(x, 'EXTENSION', 'PENDING') ||
                        hasExtensionWithStatus(x, 'SUSPENSION', 'PENDING')"
                        class="badge bg-danger rounded-pill position-relative" style="bottom: 8px; left: 31px">!</span>
                      <a href="javascript:void(0);"
                        class="action-icon text-warning hover-max-width d-flex align-items-center"
                        @click="getSuspension(x)">
                        <i class="mdi mdi-calendar-clock font-size-22 me-1"></i>
                        <span class="me-2">Contract Management</span>
                      </a>
                    </div>
                  </div>
                </b-card-header>
                <b-collapse :visible="x.visible" :accordion="`pending-accordion-${x.id}`" role="tabpanel">
                  <b-card-body class="custom-table-responsive">
                    <div class="d-flex">
                      <div class="me-3" style="min-width: max-content">
                        <div>
                          <b class="font-size-14 me-1">Attachments:</b>
                          <a href="javascript:void(0);" @click="getAttachments(x)" :id="`viewFiles-${x.id}`">[Show
                            attachments]</a>
                          <b-popover :target="`viewFiles-${x.id}`" triggers="click" placement="right"
                            :show.sync="x.viewFile" custom-class="popover-supplier">
                            <template v-slot:title>
                              <div class="d-flex align-items-center justify-content-between">
                                <small>Attachments</small>
                                <span class="bx bx-x font-size-14 cursor-pointer" @click="x.viewFile = false"></span>
                              </div>
                            </template>
                            <table class="table table-bordered" v-if="
                              !x.attachmentLoading && x.poFiles.length > 0
                            ">
                              <thead>
                                <tr>
                                  <th>File Description</th>
                                  <th style="width: 30px"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="y in x.poFiles" :key="y.id">
                                  <td @click="openDocument(y)" class="hoverable-link cursor-pointer">
                                    <div>
                                      {{ y.description }}
                                    </div>
                                    <small>{{
                                      formatDateWithTime(
                                        new Date(y.dateTimeUploaded)
                                      )
                                    }}</small>
                                  </td>
                                  <td>
                                    <i v-if="
                                      isAdmin ||
                                      y.applicationUserId ==
                                      token.ApplicationUserId
                                    " @click="removeFile(y.id, x.id)"
                                      class="cursor-pointer bx bx-trash text-danger"></i>
                                    <i v-else class="bx bx-trash text-muted"></i>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div class="text-center" v-if="
                              !x.attachmentLoading && x.poFiles.length == 0
                            ">
                              No data found
                            </div>
                            <div v-if="x.attachmentLoading" class="text-center">
                              <b-spinner variant="primary" label="Loading..."></b-spinner>
                            </div>
                          </b-popover>
                        </div>
                        <div class="mt-2">
                          <button :id="`pending-document${x.id}`" type="button" class="btn btn-sm btn-outline-success"
                            @click="x.addDocu = true">
                            <i class="bx bx-plus"></i>Add Attachments
                          </button>
                          <upload-popover :option="uploadOptions" :sourceId="x.id" @uploaded="uploadedFiles"
                            :showPV="x.addDocu" @closePopover="x.addDocu = false" :dzId="`dropzone-pending${x.id}`"
                            :pvId="`pending-document${x.id}`"></upload-popover>
                        </div>
                      </div>
                      <div class="border-start border-3 ps-2" style="width: 100%">
                        <div class="mb-2">
                          <b class="mt-2 mb-1 font-size-16">Requested Items:</b>
                        </div>
                        <div v-if="x.loading" class="p-3 d-flex align-items-center justify-content-center">
                          <div class="preloader-component me-2">
                            <div class="status">
                              <div class="spinner-chase w-25px h-25px">
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                                <div class="chase-dot"></div>
                              </div>
                            </div>
                          </div>
                          <h5 class="mb-0">Loading...</h5>
                        </div>
                        <div class="p-3 d-flex align-items-center justify-content-center"
                          v-else-if="x.rfqSupplierOffers.length == 0">
                          <h5 class="text-muted">
                            <i class="fas fa-exclamation-triangle me-2"></i>No
                            Data Found
                          </h5>
                        </div>
                        <div v-else>
                          <table width="100%">
                            <thead>
                              <tr>
                                <th class="py-2" style="min-width: 400px">
                                  <div class="row m-0">
                                    <div class="col-6 p-0 pe-5">
                                      Requested Item:
                                    </div>
                                    <div class="col-6 p-0 pe-5">
                                      Supplier Offer:
                                    </div>
                                  </div>
                                </th>
                                <th class="py-2" style="width: 250px">
                                  Requisitioning Office/Dept.:
                                </th>
                                <th class="py-2" style="width: 150px">
                                  Unit Price
                                </th>
                                <th class="py-2" style="width: 120px">
                                  Items Remaining
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="y in x.rfqSupplierOffers" :key="y.id" class="border-top">
                                <td class="py-2">
                                  <div class="row m-0">
                                    <div class="col-6 p-0 pe-5">
                                      <div>{{ y.apiResource.itemName }}</div>
                                      <small>{{
                                        y.apiResource.description
                                      }}</small>
                                    </div>
                                    <div class="col-6 p-0 pe-5">
                                      <div>{{ y.itemName }}</div>
                                      <small>{{ y.description }}</small>
                                    </div>
                                  </div>
                                </td>
                                <td class="py-2">
                                  {{ x.deliveryUnit.name }}
                                </td>
                                <td class="py-2 text-warning">
                                  {{ formatCurrency(y.unitCost) }}
                                </td>
                                <td class="py-2 text-info">
                                  {{ y.availableItemsForIar }} of
                                  {{ y.quantity }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div class="row pt-3 pb-3">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div class="tableDatas_paginate paging_simple_numbers float-end">
                  <ul class="paginate pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <contract ref="contract"></contract>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.paginate {
  z-index: -1 !important;
}

.tooltip {
  opacity: 1 !important;
}
</style>
